import React from 'react'
import { SUPPORT_PHONE, WHATSAPP_SUPPORT } from '../utils/constants'
import './RequestFab.css'

const WHATSAPP_MSG = 'Hi, I need help with NAH44.'

const RequestFab = ({ onClick, isOpen }) => {
    const handleCall = () => {
        window.open(`tel:+${SUPPORT_PHONE}`)
        onClick?.()
    }
    const handleWhatsApp = () => {
        window.open(`https://wa.me/${WHATSAPP_SUPPORT}?text=${encodeURIComponent(WHATSAPP_MSG)}`, '_blank')
        onClick?.()
    }

    return (
        <div className={`request-fab-container ${isOpen ? 'open' : ''}`}>
            {isOpen && (
                <div className="request-fab-menu">
                    <button className="request-fab-option call" onClick={handleCall} aria-label="Call">
                        <span className="fab-option-icon">📞</span>
                        <span>Call</span>
                    </button>
                    <button className="request-fab-option whatsapp" onClick={handleWhatsApp} aria-label="WhatsApp">
                        <span className="fab-option-icon">💬</span>
                        <span>WhatsApp</span>
                    </button>
                </div>
            )}
            <button
                className={`request-fab ${isOpen ? 'open' : ''}`}
                onClick={onClick}
                aria-label={isOpen ? 'Close menu' : 'Open XALL & WhatsApp'}
            >
                <span className="fab-icon">{isOpen ? '✕' : '📞'}</span>
            </button>
        </div>
    )
}

export default RequestFab
